var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow && _vm.list && _vm.list.length > 0)?_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:item.name,class:['item', index === _vm.selectIndex && 'active'],on:{"click":() => _vm.select(index)}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }